import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toArray, isEmpty, isNull } from 'lodash';

import { PATH } from '../../../constants/path';
import { COMPANY_NAME, BRAND_NAME, STATIC_ROOT } from '../../../constants';

import { fetchFaqIfNeeded } from '../../../services/faq/actions';

import { formatNumber } from '../../../utils';
import { hasCashback } from '../../../services/partner/utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import SvgComponent from '../../SvgComponent';
import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import HowItWorksComponent from '../../HowItWorksComponent';
import FaqElementComponent from '../faq/FaqElementComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import CustomerServiceComponent from '../../CustomerServiceComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './HowItWorksPage.scss';

export class HowItWorksPage extends React.Component {
    componentDidMount() {
        this.props.fetchFaqIfNeeded();
    }

    render() {
        const { i18nPage, faqData, partnersCount, i18nCustomerService, locale } = this.props;

        // Currently select the first theme with non empty faq list /!\
        const theme = faqData.find(e => !isEmpty(e.faqs)) || null;

        return (
            <main className="conteneur conteneur-mobile" id="p-cmt-ca-marche">
                <HeadComponent title={i18nPage.TITLE} description={i18nPage.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.HOW_IT_WORK_PATH}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18nPage.H1}</h1>

                <div>
                    <h3>{convertHtmlToReactDomWithParams(i18nPage.H31, BRAND_NAME)}</h3>
                    <p>
                        {convertHtmlToReactDomWithParams(
                            i18nPage.TEXT1,
                            BRAND_NAME,
                            COMPANY_NAME,
                            formatNumber(partnersCount, locale)
                        )}
                    </p>

                    <h3>{i18nPage.H32}</h3>
                    <p>{convertHtmlToReactDomWithParams(i18nPage.TEXT2, BRAND_NAME)}</p>

                    <h3>{i18nPage.H33}</h3>
                    <p>{i18nPage.TEXT3}</p>
                    <p>{i18nPage.TEXT4}</p>
                </div>

                <HowItWorksComponent showButtons />

                <div>
                    <h3>{i18nPage.H34}</h3>
                    <section className="howIsItPossible">
                        <div className="wrapper">
                            <div className="step">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/home.svg`}
                                    width="72"
                                    height="72"
                                />
                                <div className="text">
                                    <p>
                                        {convertHtmlToReactDomWithParams(
                                            i18nPage.TEXT5,
                                            partnersCount
                                        )}
                                        <LocalizedNavLink
                                            to={PATH.CASHBACK_ONLINE_MOST_POPULAR_PATH}
                                            name="howItWorks-toMostPopularCashback">
                                            {i18nPage.TEXT6}
                                        </LocalizedNavLink>
                                        <br />
                                        {convertHtmlToReactDomWithParams(i18nPage.TEXT7)}
                                    </p>
                                </div>
                            </div>
                            <div className="step">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/cash.svg`}
                                    width="72"
                                    height="72"
                                />
                                <div className="text">
                                    <p>{convertHtmlToReactDomWithParams(i18nPage.TEXT8)}</p>
                                </div>
                            </div>
                            <div className="step">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/wallet.svg`}
                                    width="72"
                                    height="72"
                                />
                                <div className="text">
                                    <p>{convertHtmlToReactDomWithParams(i18nPage.TEXT9)}</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="help-container grid">
                    <div className="faq-container inbl">
                        <div className="faq-bandeau">{i18nPage.QUESTION}</div>
                        <div className="faq-list-container">
                            {!isNull(theme) &&
                                theme.faqs
                                    .slice(0, 4)
                                    .map(faq => (
                                        <FaqElementComponent
                                            key={faq.id}
                                            faq={faq}
                                            cssClass="question-comment-ca-marche-page"
                                            forceArrowRight
                                            linkToFaqPage
                                        />
                                    ))}
                        </div>
                    </div>
                    <CustomerServiceComponent i18n={i18nCustomerService} />
                </div>
            </main>
        );
    }
}

HowItWorksPage.propTypes = {
    partnersCount: PropTypes.number.isRequired,
    i18nPage: PropTypes.object.isRequired,
    i18nCustomerService: PropTypes.object.isRequired,
    faqData: PropTypes.array
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        locale: state.i18n.locale,
        partnersCount: toArray(state.partner.partners).filter(partner => hasCashback(partner))
            .length,
        i18nPage: state.i18n.page.HOW_IT_WORKS,
        i18nCustomerService: state.i18n.feature.aide.serviceclient,
        faqData: state.faq.faqs || []
    };
};

const mapDispatchToProps = {
    fetchFaqIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(HowItWorksPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/howitworks/HowItWorksPage.js